import { ORDER_SAMPLES_IMAGE_URL } from './constants';
import orderSamplesUrl from './orderSamplesUrl';
import ChevronLink from '../../../OC/oc-chevron-link';
import Picture from '../../../OC/oc-picture';
import Text from '../../../OC/oc-text';
import { connectLocation } from '../../../location/LocationConnectors';

// this goes in the filters pane on the PYS index, after the actual filter controls
const CompactPromo = connectLocation(({ locale: { code: localeCode }, t }) => (
  <section>
    <Picture source={ORDER_SAMPLES_IMAGE_URL} alt="order-samples" />
    <div style={{ marginBottom: '15px' }}>
      <h4>{t('shingles.color_samples.heading')}</h4>
      <Text content={t('shingles.color_samples.copy')} />
    </div>
    <ChevronLink url={orderSamplesUrl(localeCode)}>
      <Text content={t('shingles.color_samples.cta_text')} />
    </ChevronLink>
  </section>
));

export default CompactPromo;
